import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import React from 'react';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import Icon from '../Icon/Icon';

const StyledLoadingSpinner = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface ILoadingSpinnerProps {
  size?: number;
  center?: boolean;
}

const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({
  size = 32,
  center = false
}) => {
  const icon = (
    <Icon icon={faSpinner} size={size} color={THEME.other.icon} spin />
  );

  if (center) {
    return <StyledLoadingSpinner>{icon}</StyledLoadingSpinner>;
  }

  return icon;
};

export default LoadingSpinner;
